import React from 'react';

// Tunisian cities with codes
const tunisianCities = [
  { Code: "TUN", EnName: "Tunis" },
  { Code: "SFX", EnName: "Sfax" },
  { Code: "SOS", EnName: "Sousse" },
  { Code: "KRN", EnName: "Kairouan" },
  { Code: "BIZ", EnName: "Bizerte" },
  { Code: "GBS", EnName: "Gabes" },
  { Code: "AM", EnName: "Ariana" },
  { Code: "GFS", EnName: "Gafsa" },
  { Code: "MNS", EnName: "Monastir" },
  { Code: "BA", EnName: "Ben Arous" },
  { Code: "KSR", EnName: "Kasserine" },
  { Code: "MDN", EnName: "Medenine" },
  { Code: "NAB", EnName: "Nabeul" },
  { Code: "TAN", EnName: "Tataouine" },
  { Code: "BJA", EnName: "Beja" },
  { Code: "JDB", EnName: "Jendouba" },
  { Code: "KEF", EnName: "Kef" },
  { Code: "MHD", EnName: "Mahdia" },
  { Code: "SBZ", EnName: "Sidi Bouzid" },
  { Code: "TZR", EnName: "Tozeur" },
  { Code: "SLI", EnName: "Siliana" },
  { Code: "KBL", EnName: "Kebili" },
  { Code: "ZAG", EnName: "Zaghouan" },
  { Code: "MAN", EnName: "Manouba" },
  { Code: "Libya", EnName: "Libya" }
];

const ClientDetailsForm = ({ 
  formData, 
  onChange, 
  errors, 
  promoCodeState, 
  onPromoCodeBlur,
  isEditMode = false // NEW - receive edit mode flag
}) => {
  return (
    <div className="bg-white overflow-hidden sm:rounded-lg border border-gray-200">
      <div className="px-6 py-5 sm:px-8 bg-white border-b border-gray-200">
        <div className="flex items-center">
          <div className="p-2 rounded-md bg-[#f5f8f7] mr-4">
            <svg className="h-6 w-6 text-[#174540]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg leading-6 font-medium text-gray-900">Informations Client</h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500">
              Détails du client pour cette commande
            </p>
          </div>
        </div>
      </div>
      
      <div className="px-6 py-6 sm:px-8 sm:py-7">
        <div className="grid grid-cols-1 gap-y-8 gap-x-6 sm:grid-cols-6">
          {/* First Name */}
          <div className="sm:col-span-3">
            <label htmlFor="client.firstName" className="block text-sm font-medium text-gray-700 mb-1">
              Prénom
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <input
                type="text"
                name="client.firstName"
                id="client.firstName"
                value={formData.client.firstName}
                onChange={onChange}
                placeholder="Prénom du client"
                className={`pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md bg-gray-50 ${errors['client.firstName'] ? 'border-red-300 text-red-900 placeholder-red-300' : ''}`}
              />
              {errors['client.firstName'] && (
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
            {errors['client.firstName'] && <p className="mt-2 text-sm text-red-600">{errors['client.firstName']}</p>}
          </div>
          
          {/* Last Name */}
          <div className="sm:col-span-3">
            <label htmlFor="client.lastName" className="block text-sm font-medium text-gray-700 mb-1">
              Nom
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <input
                type="text"
                name="client.lastName"
                id="client.lastName"
                value={formData.client.lastName}
                onChange={onChange}
                placeholder="Nom du client"
                className={`pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md bg-gray-50 ${errors['client.lastName'] ? 'border-red-300 text-red-900 placeholder-red-300' : ''}`}
              />
            </div>
          </div>
          
          {/* Phone Number */}
          <div className="sm:col-span-3">
            <label htmlFor="client.phone" className="block text-sm font-medium text-gray-700 mb-1">
              Téléphone
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <input
                type="tel"
                name="client.phone"
                id="client.phone"
                value={formData.client.phone}
                onChange={onChange}
                placeholder="Numéro de téléphone"
                className="pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md bg-gray-50"
              />
            </div>
          </div>
          
          {/* Email */}
          <div className="sm:col-span-3">
            <label htmlFor="client.email" className="block text-sm font-medium text-gray-700 mb-1">
              Email
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <input
                type="email"
                name="client.email"
                id="client.email"
                value={formData.client.email}
                onChange={onChange}
                placeholder="Email du client"
                className="pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md bg-gray-50"
              />
            </div>
          </div>
          
          {/* Address */}
          <div className="sm:col-span-6">
            <label htmlFor="client.address" className="block text-sm font-medium text-gray-700 mb-1">
              Adresse
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <input
                type="text"
                name="client.address"
                id="client.address"
                value={formData.client.address}
                onChange={onChange}
                placeholder="Adresse du client"
                className="pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md bg-gray-50"
              />
            </div>
          </div>
          
          {/* City Dropdown */}
          <div className="sm:col-span-3">
            <label htmlFor="client.city" className="block text-sm font-medium text-gray-700 mb-1">
              Ville
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-4 w-4 text-gray-400 group-hover:text-[#174540] transition-colors duration-200" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
              </div>
              <select
                name="client.city"
                id="client.city"
                value={formData.client.city}
                onChange={onChange}
                className="pl-10 py-3 shadow-sm block w-full border-0 border-b-2 border-gray-200 focus:ring-0 focus:border-[#174540] transition-all duration-300 ease-in-out text-sm rounded-t-md bg-gray-50"
              >
                <option value="">Sélectionner une ville</option>
                {tunisianCities.map((city) => (
                  <option key={city.Code} value={city.Code}>
                    {city.EnName}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              </div>
            </div>
          </div>
          
          {/* Enhanced Promo Code Input - MODIFIED for edit mode */}
          <div className="sm:col-span-3">
            <label htmlFor="client.promoCode" className="block text-sm font-medium text-gray-700 mb-1">
              Code Promo {isEditMode && (
                <span className="text-xs text-gray-500 font-normal">(lecture seule)</span>
              )}
            </label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className={`h-4 w-4 transition-colors duration-200 ${
                  isEditMode 
                    ? 'text-gray-300' 
                    : promoCodeState && promoCodeState.isValid ? 'text-green-500' : 
                      promoCodeState && promoCodeState.error ? 'text-red-500' : 
                      'text-gray-400 group-hover:text-[#174540]'
                }`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
              </div>
              <input
                type="text"
                name="client.promoCode"
                id="client.promoCode"
                value={formData.client.promoCode || ''}
                onChange={onChange}
                onBlur={onPromoCodeBlur}
                disabled={isEditMode} // DISABLED in edit mode
                placeholder={isEditMode ? (formData.client.promoCode ? formData.client.promoCode : "Aucun code promo") : "Entrez le code promo"}
                className={`pl-10 pr-12 py-3 shadow-sm block w-full border-0 border-b-2 transition-all duration-300 ease-in-out text-sm rounded-t-md ${
                  isEditMode 
                    ? 'bg-gray-100 border-gray-200 text-gray-500 cursor-not-allowed' // Disabled styling
                    : promoCodeState && promoCodeState.isValid 
                      ? 'border-green-500 bg-green-50 focus:border-green-600 focus:ring-0' 
                      : promoCodeState && promoCodeState.error 
                        ? 'border-red-500 bg-red-50 focus:border-red-600 focus:ring-0'
                        : 'border-gray-200 bg-gray-50 focus:ring-0 focus:border-[#174540]'
                } ${errors['client.promoCode'] ? 'border-red-300 text-red-900 placeholder-red-300' : ''}`}
              />
              
              {/* Status Icon - MODIFIED for edit mode */}
              <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                {isEditMode ? (
                  // Show lock icon for disabled state
                  <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
                  </svg>
                ) : promoCodeState && promoCodeState.isValidating ? (
                  <svg className="animate-spin h-5 w-5 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                ) : promoCodeState && promoCodeState.isValid ? (
                  <svg className="h-5 w-5 text-green-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                ) : promoCodeState && promoCodeState.error ? (
                  <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                  </svg>
                ) : null}
              </div>
            </div>
            
            {/* Promo Code Status Messages - MODIFIED for edit mode */}
            {isEditMode && formData.client.promoCode && promoCodeState && promoCodeState.isValid && (
              <div className="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-blue-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-blue-800">
                      Code promo existant
                    </h3>
                    <div className="mt-1 text-sm text-blue-700">
                      Réduction de <span className="font-semibold">{promoCodeState.discount} TND</span> appliquée (lecture seule)
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {!isEditMode && promoCodeState && promoCodeState.isValid && promoCodeState.discount > 0 && (
              <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded-md">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-green-800">
                      Code promo appliqué !
                    </h3>
                    <div className="mt-1 text-sm text-green-700">
                      Réduction de <span className="font-semibold">{promoCodeState.discount} TND</span> appliquée
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {!isEditMode && promoCodeState && promoCodeState.error && (
              <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <h3 className="text-sm font-medium text-red-800">
                      Code promo invalide
                    </h3>
                    <div className="mt-1 text-sm text-red-700">
                      {promoCodeState.error}
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {errors['client.promoCode'] && (
              <p className="mt-2 text-sm text-red-600">{errors['client.promoCode']}</p>
            )}
          </div>
        </div>
        <div className="mt-4">
          {/* Debug button removed */}
        </div>
      </div>
    </div>
  );
};

export default ClientDetailsForm;